// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1xrOh","col":"CardReaderDesc_col__1ZadP","label":"CardReaderDesc_label__3R_5k"};